import { cn } from "@/lib/utils"
import { ReactNode } from "react"

function FlexBreak({ className, children }: { className?: string, children?: ReactNode }) {
    return <div className={cn([
        "flex flex-col sm:flex-row gap-3 items-stretch sm:items-center justify-center",
        className])}>
        {children}
    </div>
}
export default FlexBreak